export const formOperatorId = {
  EQUAL: '{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}',
};

export const formActionTypeId = {
  ENABLE: '{5744A87E-E32C-42CC-862F-96842A0202BB}',
};
